@if (isReadonly()) {
  <div class="text-end" [attr.data-test]="'tariff-option-dropdown-input-' + selectedTariffGroupId()">
    {{ selectedTariffOption()?.optionLabel }}
  </div>
} @else {
  <div ngbDropdown placement="bottom-right" #dropdown #Dropdown="ngbDropdown" [autoClose]="true" (keyup)="keyboardNavigation($event)">
    <button
      ngbDropdownToggle
      class="btn px-2 w-100 justify-content-between btn-sm btn-dropdown-{{ colorCss() }}"
      role="combobox"
      aria-autocomplete="both"
      [attr.data-test]="'tariff-option-dropdown-input-' + selectedTariffGroupId()"
      [attr.aria-owns]="dropdownId()"
      [attr.aria-activedescendant]="getOptionId('' + selectedOptionIndex()) || null"
      [attr.aria-labelledby]="ariaLabelledBy() || null"
      [attr.data-focus-key]="computedDataFocusKey()"
    >
      <span> <i class="mr-1 fa-solid fa-{{ selectedTariffOption()?.iconLabel }}"></i>{{ selectedTariffOption()?.optionLabel }} </span>
      <i [ngClass]="{ 'fa-chevron-up': Dropdown._open, 'fa-chevron-down': !Dropdown._open }" class="ml-2 fas" aria-hidden="true"></i>
    </button>

    <div
      ngbDropdownMenu
      role="listbox"
      class="dropdown-menu-tariff border border-2 border-{{ colorCss() }} dropdown-menu-{{ colorCss() }}"
      #listbox
      [attr.id]="dropdownId()"
    >
      @for (item of options(); track item.optionLabel) {
        <button
          ngbDropdownItem
          role="option"
          class="dropdown-item dropdown-item-{{ colorCss() }}"
          [attr.id]="getOptionId('' + $index)"
          [attr.data-test]="'tariff-option-dropdown-input-' + item.option"
          [attr.data-suggestion-index]="$index"
          (click)="onOptionSelected(item)"
        >
          @if (item.iconLabel) {
            <i class="mr-1 fa-solid fa-{{ item.iconLabel }}"></i>
          }
          {{ item.optionLabel }}

          @if (showDeltaUnit(item)) {
            ({{ item.delta }} {{ item.deltaUnit }})
          }
        </button>
      }
    </div>
  </div>
}
